import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from "lucide-react"; 
import axiosInstance from '../../utils/axiosConfig';
import '../../Popup.css';
import PropTypes from 'prop-types';
import QRCodeStyling from "qr-code-styling";

const qrCodeX = new QRCodeStyling({
    width: 320,
    height: 320,
    dotsOptions: {
        color: "#f49612",
        type: "extra-rounded"
    },
    imageOptions: {
        crossOrigin: "anonymous",
        margin: 20
    }
});

const SimpleQRDialog = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const [url, setUrl] = useState('');
    const [error, setError] = useState(null);

    const ref = useRef(null);
     

    useEffect(() => {
        const fetchQrcode = async () => {
            try {
                const response = await axiosInstance.get('/product/GetQRCode');
                const data = await response.data; 

                setUrl(`${import.meta.env.VITE_APPURL}scanner/` + data);

                qrCodeX.append(ref.current);
                qrCodeX.update({
                    data: `${import.meta.env.VITE_APPURL}scanner/` + data
                });
            } catch (error) {
                console.error('Error fetching qrcode:', error);
                setError(error.message);
            }
        };

        if (isOpen) {
            fetchQrcode();
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4 relative">
                <button
                    onClick={onClose}
                    className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
                    aria-label={t('common.close')}
                >
                    <X size={24} />
                </button>

                <div className="text-lg font-inter text-ps-blue-dark mb-4">
                    {t('scanner.title')}
                </div>

                <div className="w-full aspect-square bg-gray-100 rounded-lg border-2 border-ps-orange mb-4 flex items-center justify-center">
                    <div ref={ref} />
                    {error && (
                        <p className="text-red-500">{t('common.error')}: {error}</p>
                    )}
                </div>

                <p className="text-center text-gray-600 font-inter">
                    {t('products.scanQRCode')}
                </p>
            </div>
        </div>
    );
};

SimpleQRDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default SimpleQRDialog;